import { validateMaterialWidth } from '../../helpers/validators'
import { onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const calculatedMaterialWidthColumn: CalculationColumn = {
    dataIndex: ['calculated', 'materialWidth'],
    title: 'Ширина роля',
    width: 62,
    validator: validateMaterialWidth,
    onCell: onAnyStandardCell,
}
